(function() {

    'use strict';

    /**
     * Bundle Component
     * @type BundleCmpCtrl
     * @name BundleCtrl
     */
    var productQuantityCmp = {
        bindings: {
            onSelected: '&',
            product: '<',
            isEditable: '<'
        },
        controller: productQuantityCmpCtrl,
        templateUrl: 'product-quantity.component.html'
    };

    angular.module('itxApp.common')
        .component('productQuantity', productQuantityCmp);

    productQuantityCmpCtrl.$inject = [
        'ItxScreenSizeSvc',
        '$rootScope'
    ];

    function productQuantityCmpCtrl(
        ItxScreenSizeSvc,
        $rootScope
    ) {
        var _this = this;
        
        _this.$onInit = function () {
            _this.isMobile = ItxScreenSizeSvc.isMobile();
            _this.numbers = _.range(1,26);
        };

        _this.$onChanges = function (changes) {
            if (changes && changes.product) {
                _this.selected = changes.product.currentValue.quantity;
            }
        };

        $rootScope.$on('itx-shop-cart:updated',function () {
            _this.selected = _this.product.quantity;
        });
        
        _this.onSelectChange = function() {
            _this.onSelected({quantity: _this.selected});
        };

        _this.updateQuantity = function(type) {
            var newQuantity = _this.selected;
            switch (type) {
                case 'decrement':
                    if(_this.selected <= 0) {
                        newQuantity = 0;
                    } else {
                        newQuantity = _this.selected - 1;
                    }
                    break;
                    
                case 'increment':
                    newQuantity = _this.selected + 1;
                    break;
            }
            _this.onSelected({quantity: newQuantity});
        };
    }

})();
